import React, { useState } from "react";

import { GenericLogs } from "../../../../components/GenericLogs/GenericLogs";
import MultiFilterDropdown from "../../../../components/MultiFilterDropdown/MultiFilterDropdown";
import translate from "../../../../services/Translate";
import { fetchMeetingLogsDetailed } from "./MeetingLogs.function";
import { transformMeetingLog } from "./MeetingLogs.transform";

const knownLogTypes = ["user_attendance", "cohort_attendance", "animators", "attendance", "resource"];
const otherLogType = "other";
const logTypes = [...knownLogTypes, otherLogType];
const logActions = ["added", "edited", "deleted"];

const MeetingLogs = ({ meetingId, language }: { meetingId: string; language: string }) => {
  const [selectedLogActions, setSelectedLogActions] = useState<string[]>([]);
  const [selectedLogTypes, setSelectedLogTypes] = useState<string[]>([]);

  const _filterLog = (log: { action?: string; target?: { type?: string } }) => {
    const logType = log.target?.type || otherLogType;
    const normalizedType = knownLogTypes.includes(logType) ? logType : otherLogType;
    const matchesAction = !selectedLogActions.length || selectedLogActions.includes(log.action?.toLowerCase() || "");
    const matchesType = !selectedLogTypes.length || selectedLogTypes.includes(normalizedType);

    return matchesAction && matchesType;
  };

  const _clearFilters = () => {
    setSelectedLogActions([]);
    setSelectedLogTypes([]);
  };

  const hasActiveFilters = selectedLogActions.length > 0 || selectedLogTypes.length > 0;

  return (
    <GenericLogs
      entityId={meetingId}
      language={language}
      fetchLogs={fetchMeetingLogsDetailed}
      filterLog={_filterLog}
      headerContent={
        <React.Fragment>
          <div className="w-fit mt-1">
            <MultiFilterDropdown
              buttonWidth="180px"
              defaultValue={selectedLogTypes}
              inputTitle={translate(language, "PAGES.MEETING.LOGS.FILTERS.TYPE_LABEL")}
              language={language}
              onSelectTags={(types) => setSelectedLogTypes(types.map(String))}
              sortAlphabetically={false}
              tags={logTypes.map((type) => ({
                display: translate(language, `PAGES.MEETING.LOGS.FILTERS.TYPES.${type.toUpperCase()}`),
                value: type,
              }))}
            />
          </div>
          <div className="w-fit mt-1">
            <MultiFilterDropdown
              buttonWidth="150px"
              defaultValue={selectedLogActions}
              inputTitle={translate(language, "PAGES.MEETING.LOGS.FILTERS.ACTION_LABEL")}
              language={language}
              onSelectTags={(actions) => setSelectedLogActions(actions.map(String))}
              sortAlphabetically={false}
              tags={logActions.map((action) => ({
                display: translate(language, `COMPONENTS.GENERIC_LOGS.ACTIONS.${action.toUpperCase()}`),
                value: action,
              }))}
            />
          </div>
          {hasActiveFilters && (
            <div
              className="ms-1 clickable dark-gray-font text-decoration-underline xs-regular w-fit align-content-center"
              onClick={_clearFilters}
            >
              {translate(language, "PAGES.MEETING.LOGS.FILTERS.CLEAR")}
            </div>
          )}
        </React.Fragment>
      }
      translationPrefix="PAGES.MEETING.LOGS.ATTRIBUTES"
      transformDetailedLog={transformMeetingLog}
      detailedConfig={{
        enabled: false,
        value: true,
        onToggle: () => null,
      }}
    />
  );
};

export default MeetingLogs;
